export default "__VITE_ASSET__BNE6KJk2__"